import React from 'react';
import { SkeletonProps } from 'typings';

export const Skeleton: React.FC<SkeletonProps> = ({ direction = 'column', justifyContent, skeletons }) => {
    return (
        <bds-grid md="12" gap="2" direction={direction} justify-content={justifyContent}>
            {skeletons.map((skeleton, index) => (
                <bds-skeleton
                    key={index}
                    shape={skeleton.shape}
                    width={skeleton.width}
                    height={skeleton.height}
                ></bds-skeleton>
            ))}
        </bds-grid>
    );
};
